const dateFormat = {
  methods: {
    dateFormatYMD(datetime) {
      return this.$moment(datetime).format('YYYY-MM-DD');
    },
    parseToTimeStamp(time) {
      return this.$moment(time).format('X');
    },
    checkItemActive(item) {
      if (item && item.length > 0) {
        return item.filter((itemPost) => itemPost.active);
      }
      return item;
    },
    postSort(posts) { // 讓單元根據發布時間排序
      if (posts && posts.length > 0) {
        return posts.sort((a, b) => a.opened_at.timestamp - b.opened_at.timestamp);
      }
      return posts;
    },
    // window.ga
    gaTrackLink(eventCategory, eventAction, eventLabel, url) { // 送事件後跳轉
      // 最新公告 - 點擊 [公告]: ga('Dashboard', 'Click Announcement', '公告標題', '連結')
      if (eventCategory && eventCategory !== '') {
        if (eventLabel || eventLabel == '') {
          ga('send', 'event', eventCategory, eventAction); // 沒有 Label
        } else {
          ga('send', 'event', eventCategory, eventAction, eventLabel);
        }
      }
      window.location.href = url;
    },
    gaTrackEvent(eventCategory, eventAction, eventLabel, eventValue = '') { // 包在函式裡，不跳轉
      if (eventValue || eventValue == '') {
        ga('send', 'event', eventCategory, eventAction, eventLabel);
      } else {
        ga('send', 'event', eventCategory, eventAction, eventLabel, eventValue);
      }
    },
  },
};
export default dateFormat;
